import * as Sentry from '@sentry/react';

// Will get consents from dataLayer
const useCookieConsents = () => {
  return {
    getLiveConsents
  };
};

const getLiveConsents = () => {
  let dataLayer = [];

  if (process.env.REAL_ENV === 'local' || process.env.REAL_ENV === 'staging') {
    // Push a dummy dataLayer consents while on local / stg environments
    dataLayer.push([
      'consent',
      'update',
      {
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        analytics_storage: 'granted',
        functionality_storage: 'granted',
        personalization_storage: 'granted',
        security_storage: 'granted'
      }
    ]);
  } else {
    dataLayer = window.dataLayer;
  }

  // Get user consents from dataLayer if they exist:
  const consentsLayer = dataLayer?.filter(dl => dl[0] === 'consent' && dl[1] === 'update')
    ?.pop();

  if (!consentsLayer) {
    Sentry.withScope(scope => {
      scope.setExtra('dataLayer', window.dataLayer);
      Sentry.captureMessage('No consents object found in useGetConsents Hook.', 'warning');
    });

    return {};
  }

  return consentsLayer?.[2];
};

export default useCookieConsents;
